import { Grid, Image } from "antd";
import MobileBackground from "./images/bg_mobile.webp";
import PCBackground from "./images/bg_pc.webp";

const Page403 = () => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    // <ContentWrapper>
    <Image
      preview={false}
      src={screens.sm ? PCBackground : MobileBackground}
      width={"100%"}
    />
    // </ContentWrapper>
  );
};

export default Page403;
